import { IDashboardBootstrapDto } from 'common/src/types/luzmo.dtos';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import { deleteRequest, getRequest } from 'portal/src/api/requestTypes';

export const LUZMO_DASHBOARDS_BOOTSRAP = `${API_BASE_PATHS.LUZMO_DASHBOARDS}/bootstrap`;

export const getDashboardBootstrap =
  async (): Promise<IDashboardBootstrapDto> =>
    await getRequest(LUZMO_DASHBOARDS_BOOTSRAP);

export const deleteCustomDashboardService = async (
  dashboardId: string,
  key: string,
  token: string,
): Promise<void> =>
  await deleteRequest(`${API_BASE_PATHS.LUZMO_DASHBOARDS}/${dashboardId}`, {
    key,
    token,
  });
